import { evidenceResult } from './evidenceResult';

export async function askSources(client, question, source, publicOnly) {
  const response = await client.post('/mahmut/ask', {
    question: question.trim(), source, public_only: publicOnly,
  }, { validateStatus: () => true });
  return evidenceResult({ status: response.status, ok: response.status >= 200 && response.status < 300 }, response.data);
}
